<script lang="ts">
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import imgVinyl from "../../../core/assets/images/vinyl.svg";
	import imgDevices from "../../../core/assets/images/devices.png?webp&w=897&imagetools";
	import imgSilueta from "../../../core/assets/images/silueta.png?webp&w=572&imagetools";
	export let keepAnEyeOnThingsHeadline = "";
	export let keepAnEyeOnThingsDescription = "";
	/* eslint-disable svelte/no-at-html-tags */
</script>

<section class="bg-secondary-300 relative pb-[24rem] text-white">
	<div class="container py-32">
		<div class="relative z-30 mx-auto max-w-2xl text-center">
			<h2 class="text-primary text-md leading-[1.23] lg:text-lg">{@html keepAnEyeOnThingsHeadline}</h2>
			<p class="text-base font-medium">{@html keepAnEyeOnThingsDescription}</p>
		</div>
	</div>
	<StaticPicture
		class="absolute bottom-32 z-10 aspect-square w-[20rem] animate-[spin_2s_linear_infinite] lg:-bottom-[25rem] lg:-left-96 lg:w-[903px] xl:-bottom-56"
		width={903}
		height={903}
		image={imgVinyl}
		alt="Vinyl"
	/>
	<StaticPicture
		class="absolute bottom-0 left-0 right-0 z-20 mx-auto w-[897px] max-w-full lg:-bottom-44"
		width={897}
		height={494}
		image={imgDevices}
		alt="Vinyl"
	/>
	<StaticPicture
		imgClass=""
		class="absolute -right-32 bottom-5 z-10 mx-auto w-[572px] max-w-full lg:bottom-0 lg:right-0"
		width={572}
		height={655}
		image={imgSilueta}
		alt="Vinyl"
	/>
</section>
